<template>
  <div class="perm-catalog">
    <header class="page-header">
      <button class="back" @click="$router.back()"><van-icon name="arrow-left"/></button>
      <div class="page-title">权限目录</div>
      <div class="header-right"></div>
    </header>

    <main class="content">
      <section v-if="loading" class="loading"><van-loading/></section>

      <section v-else class="modules">
        <div v-for="mod in catalog" :key="mod.code" class="module-card">
          <div class="module-head" @click="toggleMod(mod.code)">
            <span class="expand-arrow" :class="{ expanded: expandedMods[mod.code] }">
              <van-icon name="arrow"/>
            </span>
            <span class="mod-icon">
              <van-icon name="shield-o"/>
            </span>
            <span class="mod-label">{{ mod.name }}</span>
            <span class="mod-count">{{ modTotalCount(mod) }} 个权限</span>
          </div>
          <div v-show="expandedMods[mod.code]" class="resources">
            <div v-for="res in mod.resources" :key="res.code" class="resource-block">
              <div class="resource-head" @click="toggleRes(mod.code, res.code)">
                <span class="expand-arrow" :class="{ expanded: expandedRes[mod.code + '.' + res.code] }">
                  <van-icon name="arrow"/>
                </span>
                <span class="res-label">{{ res.name }}</span>
                <span class="res-count">{{ res.actions.length }} 项</span>
              </div>
              <div v-show="expandedRes[mod.code + '.' + res.code]" class="actions">
                <div v-for="act in res.actions" :key="act.code" class="action-row">
                  <span class="act-name">{{ act.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-else-if="!catalog.length" class="empty">
        <van-empty description="暂无权限数据"/>
      </section>
    </main>
  </div>
</template>

<script>
import identityApi from '@/api/identity';

export default {
  name: 'BossPermissionCatalog',
  data() {
    return {
      catalog: [],
      loading: true,
      expandedMods: {},
      expandedRes: {}
    };
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const data = await identityApi.permissionCatalog();
        this.catalog = Array.isArray(data) ? data : (data.catalog || []);
        // 默认展开全部模块
        for (const m of this.catalog) this.$set(this.expandedMods, m.code, true);
      } catch (e) {
        this.$toast.fail(e.message || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    toggleMod(code) {
      this.$set(this.expandedMods, code, !this.expandedMods[code]);
    },
    toggleRes(modCode, resCode) {
      const key = modCode + '.' + resCode;
      this.$set(this.expandedRes, key, !this.expandedRes[key]);
    },
    modTotalCount(mod) {
      return mod.resources.reduce((s, r) => s + r.actions.length, 0);
    }
  }
};
</script>

<style scoped>
.page-header {
  position: sticky; top: 0; z-index: 10;
  height: 44px; background: #fff;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 12px; border-bottom: 1px solid #eee;
}
.back, .to-role { background: none; border: 0; font-size: 14px; }
.to-role { color: #1989fa; font-weight: 500; }
.page-title { font-weight: 500; }
.header-right { display: flex; align-items: center; }
.content { padding: 12px 12px calc(66px + env(safe-area-inset-bottom)); }

.modules { display: flex; flex-direction: column; gap: 10px; }

.module-card {
  background: #fff; border-radius: 10px; padding: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,.04); overflow: hidden;
}

.module-head {
  background: #fafafa; padding: 10px 14px;
  display: flex; align-items: center; gap: 8px;
  border-bottom: 1px solid #f0f0f0; cursor: pointer;
}
.expand-arrow { color: #bbb; transition: transform .15s; width: 16px; display: inline-flex; justify-content: center; }
.expand-arrow.expanded { transform: rotate(90deg); }
.mod-icon {
  width: 28px; height: 28px; border-radius: 6px;
  background: #e8f4ff; color: #1989fa;
  display: flex; align-items: center; justify-content: center; font-size: 14px;
  flex-shrink: 0;
}
.mod-label { flex: 1; font-size: 15px; font-weight: 600; color: #1a1a1a; }
.mod-count { font-size: 12px; color: #999; font-weight: 400; }

.resources { padding: 4px 0; }
.resource-block { border-top: 1px dashed #eee; }
.resource-head {
  display: flex; align-items: center; gap: 6px; cursor: pointer;
  padding: 10px 14px; font-size: 14px; color: #333;
}
.res-label { flex: 1; color: #555; font-weight: 500; }
.res-count { font-size: 11px; color: #999; }

.actions { padding: 4px 14px 10px 40px; display: flex; flex-direction: column; gap: 2px; }
.action-row {
  padding: 6px 10px; border-radius: 6px;
  background: #f8f9fb;
}
.act-name { font-size: 13px; color: #333; }

.loading, .empty { padding: 40px 0; text-align: center; }
</style>



// WEBPACK FOOTER //
// src/views/boss/identity/PermissionCatalog.vue